import { capitalizza, DownloadFile, ICONE, MIME_TYPES, BaseScatola, BaseGridLayout, abbreviaStringaSeServe } from '@lucan/base-ui'
import { creaUuidPerAttachment } from 'configuration/ConfigurazioneApi'
import Testo from 'components/ui/Testo'

export default function ScatolettaDownloadAllegato(props) {
  const { allegato, chiavePerUuid, ...rest } = props
  const { id, nome } = allegato

  return (
    <BaseScatola outlined {...rest}>
      <BaseGridLayout justifySpaceBetween alignCenter>
        <BaseGridLayout alignCenter spacing={1}>
          <ICONE.ALLEGATO />
          <Testo>{abbreviaStringaSeServe(capitalizza(nome))}</Testo>
        </BaseGridLayout>

        <DownloadFile
          file={{
            uuid: creaUuidPerAttachment(chiavePerUuid, id),
            mimetype: MIME_TYPES.PDF,
            filename: capitalizza(nome)
          }}
          propsBottoneScarica={{ sx: { m: 0, p: 0 } }}
          nascondiIconaFormatoFile
          nascondiNomeFile
          opzioniRichiestaHttp={{withCredentials: true}}
        />
      </BaseGridLayout>
    </BaseScatola>
  )
}